import React from 'react';
import { Card } from 'react-bootstrap';

interface ProjectSectionCardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  headerRight?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

const ProjectSectionCard: React.FC<ProjectSectionCardProps> = ({
  title,
  subtitle,
  headerRight,
  className = '',
  bodyClassName = '',
  children,
}) => (
  <Card className={`project-section-card dashboard-section-card ${className}`.trim()}>
    {(title || subtitle || headerRight) && (
      <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          {title && <span className="fw-bold">{title}</span>}
          {subtitle && <small className="d-block text-muted">{subtitle}</small>}
        </div>
        {headerRight}
      </Card.Header>
    )}
    <Card.Body className={bodyClassName}>{children}</Card.Body>
  </Card>
);

export default ProjectSectionCard;
